var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22222 1C2.22222 0.447715 2.66994 0 3.22222 0H16.7778C17.3301 0 17.7778 0.447715 17.7778 1C17.7778 1.55228 17.3301 2 16.7778 2H3.22222C2.66994 2 2.22222 1.55228 2.22222 1ZM0 5.44444C0 4.89216 0.447715 4.44444 1 4.44444H19C19.5523 4.44444 20 4.89216 20 5.44444C20 5.99673 19.5523 6.44444 19 6.44444H1C0.447715 6.44444 0 5.99673 0 5.44444ZM3.22222 8.88889C2.66994 8.88889 2.22222 9.33661 2.22222 9.88889C2.22222 10.4412 2.66994 10.8889 3.22222 10.8889H16.7778C17.3301 10.8889 17.7778 10.4412 17.7778 9.88889C17.7778 9.33661 17.3301 8.88889 16.7778 8.88889H3.22222Z",
    fill: "#545451"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/icon-hamburger.789cea977dd6a12380235ec2a60d1d9d.svg";
export { ForwardRef as ReactComponent };